 
import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyDesignOverview, StudyDesignArms, StudyCopyBlock } from '../index';
import styled from 'styled-components';
 
 
const ComponentWrapperStyled = styled(ComponentWrapper)`
    >div: nth-child(2) {
        tr td dl dd{
            text-align: left !important;
        }
    }
    .box-green dd {
    > div > div {
        margin: 16px 0;
        }
    }
    .bold-key{
     font-weight: 600;
     margin-top:0px !important;
     padding-top:24px;
    }
     .box-gradient{
     dt{
     padding-bottom:0px;
     }
     p{
     margin: 10px auto;
     }
     ul{
     li{
     :last-child{
     margin-bottom:0;
        }
     }
     }
     }
`;
 
const CustomStudyCopyBlockWrap = styled.div`
> div {
    margin-top: -20px;
}
`;
 
const MIBC = () => (
 
    <ComponentWrapperStyled>
        <StudyDesignOverview
            title="Study Overview"
            description="Phase 3, open-label, randomized, active-controlled, multicenter study of a neoadjuvant and adjuvant regimen of KEYTRUDA + EV and RC + PLND vs RC + PLND alone in cisplatin-ineligible patients with MIBC (N=344)<sup>7</sup>"
            data={[
                [
                    {  
                        title: 'Patient Eligibility Criteria',
                        description: `
                        <p class="bold-key">Key Inclusion Criteria</p>
                        <p>Patients with previously untreated MIBC (with predominant urothelial carcinoma histology):</p>
                        <ul>
                            <li>Who were ineligible for or declined cisplatin-based chemotherapy</li>
                            <li>Who were candidates for RC + PLND</li>
                        </ul>
                        <p class="bold-key">Key Exclusion Criteria</p>
                        <p>Patients with:</p>
                        <ul>
                            <li>Primary non-bladder urothelial cancer (ie, cancer of the ureter, urethra, or renal pelvis)</li>
                            <li>Active autoimmune disease that required systemic therapy within 2 years of treatment</li>
                            <li>Medical condition that required immunosuppression</li>
                        </ul>                       
                    `,
                        type: 'box-gradient',
                        colspan: 2
                    }
                ],
                [
                    {
                        type: 'arrow-green',
                        colspan: 2
                    }
                ],
                [
                    {
                        title: 'Randomized 1:1 (N=344)',
                        colspan: 2
                    }
                ],
            ]} />
 
        <StudyDesignArms title="Study Arms" arms={[
            {
                title: "Perioperative KEYTRUDA + EV (n=170)",
                data: [
                    [
                        {
                            title: 'Neoadjuvant Treatment',
                            description: [
                                            {
                                                text: `KEYTRUDA 200 mg<sup>a</sup> on day 1 of each 21‑day cycle for 3 cycles`,
                                                // textCenter: true
                                            },
                                            {
                                                text: `EV 1.25 mg/kg on days 1 and 8 of each 21‑day cycle for 3 cycles`,
                                                conditional: 'and',
                                                // textCenter: true
                                            },
                                        ],
                            type: 'box-green'
                        }
                    ],
                    [
                        {
                            type: 'arrow-green'
                        }
                    ],
                    [
                        {
                            title: 'RC + PLND',
                            type: 'box-green'
                        }
                    ],
                    [
                        {
                            type: 'arrow-green'
                        }
                    ],
                    [
                        {
                            title: 'Adjuvant Treatment',
                            description: [
                                            {
                                                text: `KEYTRUDA 200 mg<sup>a</sup> on day 1 of each 21‑day cycle for 14 cycles`,
                                                // textCenter: true
                                            },
                                            {
                                                text: `EV 1.25 mg/kg on days 1 and 8 of each 21‑day cycle for 6 cycles`,
                                                conditional: 'and',
                                                // textCenter: true
                                            },
                                        ],
                            type: 'box-green'
                        },
                    ],
                ]
            },
            {
                title: "RC + PLND Alone (n=174)",
                data: [
                    [
                        {
                            title: 'Immediate RC + PLND alone',
                            type: 'box-gray'
                        }
                    ],
                ]
            }
        ]}
        />
 
        <CustomStudyCopyBlockWrap>
            <StudyCopyBlock
                description={`
                    <ul>
                        <li>Treatment continued until completion of study medications, disease progression, not undergoing or refusal of RC + PLND, disease recurrence in the adjuvant phase, or unacceptable toxicity.</li>
                        <li>Assessment of tumor status, including CT/MRI, was performed at baseline, within 5 weeks prior to RC + PLND, and at 6 weeks post-radical cystectomy. Following RC + PLND, assessment of tumor status, including cystoscopy and urine cytology for patients who did not undergo surgery, was performed every 12 weeks up to 2 years, and every 24 weeks thereafter.</li>
                        <li>The trial was not designed to isolate the effect of KEYTRUDA in each phase (neoadjuvant or adjuvant) of treatment.</li>
                    </ul>
                `}
            />
        </CustomStudyCopyBlockWrap>

        <StudyCopyBlock
            title="Stratification"
            description={`
            <ul>
                <li>Tumor stage (T2N0 vs T3/T4aN0 vs T1-T4aN1)</li>
                <li>Cisplatin eligibility (cisplatin-ineligible vs cisplatin-eligible but declined)</li>
                <li>Geographic region (United States vs European Union vs Rest of the World)</li>
            </ul>`}
        />
 
        <StudyCopyBlock
            title="End Points"
            description={`
                <p>Major Efficacy Outcome Measure</p>
                <ul>
                    <li>Event-free survival (EFS)<sup>b</sup> &#8211; defined as time from randomization to the first of: disease progression preventing curative surgery, failure to undergo surgery for participants with muscle invasive residual disease, incomplete surgical resection, local or distant recurrence after surgery, or death.</li>
                </ul>
                <p>Additional Efficacy Outcome Measure</p>
                <ul>
                    <li>Overall Survival (OS)</li>
                    <li>Pathological complete response (pCR) rate<sup>c</sup></li>
                </ul>
            `}
        />
 
        <StudyCopyBlock
            title="Patient Characteristics"
            description={`
                <ul>
                    <li><strong>Sex:</strong> 78% male</li>
                    <li><strong>Median age:</strong> 73 years (46 to 87 years)</li>
                    <li><strong>Race:</strong> White, 78%; Asian, 16%; Multiple, 3.2%; Black or African American, 1.2%; American Indian or Alaska Native, 0.3%; Missing, 1.2%; Hispanic or Latino, 6%, Not Hispanic or Latino, 91%; Not reported, 2.9%</li>
                    <li><strong>ECOG PS:</strong> 0: 57%; 1: 29%; 2: 14%</li>
                    <li><strong>Pathologic staging and nodal status:</strong> T2N0: 18%; T3/T4aN0: 77%; T1-T4aN1: 4.9%</li>
                    <li><strong>Histology of tumor:</strong> Pure urothelial carcinoma: 91%; Urothelial carcinoma with squamous differentiation: 4.4%; Urothelial carcinoma with glandular differentiation: 2.6%; Urothelial carcinoma with other histologic variants: 2%</li>
                    <li><strong>Cisplatin-ineligible patients (n=281):</strong> CrCl 30-59 mL/min: 72%; ECOG PS 2: 17%; Grade ≥2 hearing loss: 21%; NYHA Class III heart failure: 3.9%; Met >1 cisplatin-ineligibility criterion: 13%</li>
                    <li>A total of 149 patients (88%) in the KEYTRUDA + EV arm and 156 patients (90%) in the RC + PLND alone arm underwent RC + PLND. A total of 29 patients (17%) in the RC + PLND alone arm received adjuvant nivolumab.</li>
                </ul>
            `}
            footnotes={[
                {
                    label: 'a.',
                    text: "IV infusion over 30 minutes. When administered on the same day, KEYTRUDA was given after EV."
                },
                {
                    label: 'b.',
                    text: "Assessed by BICR."
                },
                {
                    label: 'c.',
                    text: "As assessed by blinded independent pathology review."
                }
            ]}
            definitions={"CrCI = creatinine clearance; NYHA = New York Heart Association."}
        />
    </ComponentWrapperStyled>
);
 
export default MIBC